module.exports = __webpack_public_path__ + "img/bg.707861de.jpg";